module.exports = __webpack_public_path__ + "img/expand_more.ae423a00.svg";